import WidgetTiles from './WidgetTiles';

export default WidgetTiles;
